import React from 'react';

export const ProposalSourceContext = ({ context, missing, reviewAll, onReview }) => {
  if (!context) return null;
  const entries = Object.entries(context.prefilled || {});
  return <div className="mt-5 border-y border-gray-200 py-4 text-sm" data-testid="proposal-source-context">
    <h3 className="font-semibold text-gray-900" data-testid="proposal-source-heading">From Value Scorecard</h3>
    <p className="mt-1 text-gray-600" data-testid="proposal-source-company">
      {context.company?.company_name} · {context.company?.currency || 'Currency to confirm'}
    </p>
    <details className="mt-3" data-testid="proposal-source-details">
      <summary data-testid="proposal-source-toggle" className="cursor-pointer text-teal-700">{entries.length} available context fields</summary>
      <dl className="mt-3 space-y-3">
        {entries.map(([key, value]) => <div key={key}>
          <dt data-testid={`proposal-source-label-${key}`} className="font-medium text-gray-700 capitalize">{key.replaceAll('_', ' ')}</dt>
          <dd data-testid={`proposal-source-value-${key}`} className="whitespace-pre-line break-words text-gray-600 mt-1">{Array.isArray(value) ? value.join(', ') : value}</dd>
        </div>)}
      </dl>
      {context.estimated_investment && <p data-testid="proposal-investment-estimate" className="mt-3 text-amber-800">Scorecard investment estimate: {String(context.estimated_investment)} — not an approved client budget.</p>}
    </details>
    <p data-testid="proposal-missing-summary" className="mt-3 text-amber-800">
      {missing.length ? `To confirm: ${missing.map(item => item.label).join(', ')}.` : 'Client information gaps addressed.'}
    </p>
    <p data-testid="proposal-gap-policy" className="mt-1 text-gray-500">Missing estimable details use labelled planning scenarios. Verify all estimates; client facts and approved commercial terms still require confirmation.</p>
    {context.planning_estimates?.items?.length > 0 && <details className="mt-3" data-testid="proposal-planning-estimates">
      <summary data-testid="proposal-estimates-toggle" className="cursor-pointer text-amber-800">Planning estimates — verify before use</summary>
      <ul className="mt-3 space-y-3">
        {context.planning_estimates.items.map(item => <li key={item.id} data-testid={`proposal-estimate-${item.id}`}>
          <p className="font-medium text-gray-800">{item.area}: {item.range}</p>
          <p className="text-amber-800">{item.kind}</p>
          <p className="text-gray-600 mt-1">{item.basis}</p>
          <p className="text-gray-600 mt-1">{item.verify}</p>
        </li>)}
      </ul>
      <ul className="mt-3 space-y-1">{(context.planning_estimates.references || []).map(ref => <li key={ref.id}>
        <a data-testid={`proposal-benchmark-${ref.id}`} href={ref.url} target="_blank" rel="noopener noreferrer" className="text-teal-700 underline">{ref.id}: {ref.title}</a>
      </li>)}</ul>
    </details>}
    <button type="button" data-testid="proposal-review-context" aria-pressed={reviewAll} onClick={onReview}
      className="mt-3 text-teal-700 underline underline-offset-2 hover:text-teal-900">
      {reviewAll ? 'Show missing fields only' : 'Review all client context'}
    </button>
  </div>;
};